import React, { useRef, useState } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import StableInterviewPage from '../modules/interview/pages/InterviewPage';
import { InterviewFeedback } from '../types/interviews';

/**
 * Wrapper component for active public interviews
 * This component handles the interview completion and redirects to thank you screen
 */
const PublicInterviewActivePage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const location = useLocation();
  const videoRef = useRef<HTMLVideoElement>(null);
  const [videoStream, setVideoStream] = useState<MediaStream | null>(null);

  // Get candidate info from navigation state
  const candidateName = location.state?.candidateName || 'Guest';
  const candidatePhoto = location.state?.candidatePhoto;

  const handleInterviewComplete = async (
    interviewId: string,
    seriesId: string | undefined,
    feedbackApplicable: boolean,
    feedbackData?: InterviewFeedback | null
  ) => {
    console.log('[PublicInterviewActive] Interview completed:', {
      interviewId,
      seriesId,
      feedbackApplicable,
      unique_id: id
    });

    // Navigate back to the screening interview page with a flag to show thank you screen
    navigate(`/screening-interview/${id}`, {
      state: {
        interviewCompleted: true,
      },
      replace: true,
    });
  };

  return (
    <StableInterviewPage
      videoRef={videoRef}
      videoStream={videoStream}
      onInterviewComplete={handleInterviewComplete}
      onVideoStreamChange={setVideoStream}
      userData={{
        name: candidateName,
        profileImage: candidatePhoto,
        interviewGoals: null,
        minutesLeft: 9999, // No time limit for public interviews
      }}
    />
  );
};

export default PublicInterviewActivePage;
